import script from "./SupplierDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierDialog.vue?vue&type=script&setup=true&lang=js"

import "./SupplierDialog.vue?vue&type=style&index=0&id=63c90904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c90904"]])

export default __exports__